<template>
  <section>
    <div class="container table" v-html="htmlString"/>
    <div class="container cta-table pt-0">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr style="width: 100%">
              <th class="px-0 text-center" style="width: 39%">&nbsp;</th>
              <th v-for="name in names" :key="name" class="px-0 text-center" style="width: 19%">
                <v-btn fab nuxt color="accent" class="no-line" @click="emitSelection(name)">
                  <font-awesome-icon :icon="['far', 'shopping-cart']"/>
                </v-btn>
              </th>
            </tr>
          </thead>
        </template>
      </v-simple-table>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    htmlString: {
      default: '',
      type: String,
    },
    names: {
      type: Array,
      default: () => ([]),
    },
  },
  methods: {
    emitSelection(name) {
      this.$emit('product-selection', name);
    },
  },
};
</script>

<style lang="sass" scoped>
.table
  display: none
  @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
    display: block
    ::v-deep p
      padding-left: 0 !important

      & strong
        font-family: $heading-font-family
        font-size: map-deep-get($headings, 'h5', 'size') !important
        text-transform: uppercase

    ::v-deep table
      border-collapse: separate
      border-spacing: 0

      thead
        background-color: var(--v-primary-base)

        th
          color: white
          padding: 20px 12px
          border: 1px solid var(--v-primary-base)
          &:first-of-type
            border-top-left-radius: 6px
          &:last-of-type
            border-top-right-radius: 6px

      tbody
        td
          border: 1px solid var(--v-secondary-lighten1)
          padding: 6px 12px

          &:first-of-type
            padding-left: 16px
            border-left: 2px solid var(--v-secondary-lighten1)

          &:last-of-type
            border-right: 2px solid var(--v-secondary-lighten1)

        td:not(:first-of-type)
          text-align: center

.cta-table
  ::v-deep table
    border-collapse: separate
    border-spacing: 0

    th
      border-bottom: 0 !important
</style>
